import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BloodDonation from './components/BloodDonation';
import UpcomingEvents from './components/UpcomingEvents';
import Contact from './components/Contact';
import About from './components/About';
import FloatingDonateButton from './components/FloatingDonateButton';
import Home from './components/Home';
import DonationPage from './components/DonationPage';
import ScrollToTop from './components/ScroleToTop';
function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App bg-gradient-to-r from-[#6dd5ed] to-[#eecda3] min-h-screen">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blood-donation" element={<BloodDonation />} />
          <Route path="/events" element={<UpcomingEvents />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/donate" element={<DonationPage />} />
        </Routes>
        <Footer />
        <FloatingDonateButton />
      </div>
    </Router>
  );
}

export default App;
